import React from "react";
import { useNavigate } from "react-router-dom";
import CarouselCard from "../../../components/Carousel";
import { FleetrifyBgs } from "../../../assets/video";
import { FLEETRIFYROUTEPATH } from "../../../routes/routesPath";
import { useCompanySetup } from "../../../controllers/useCompanySetup";

const IndividualSetUp = () => {
  const navigate = useNavigate();

  const { handleNext, sending } = useCompanySetup();

  const slides = [
    {
      title: "Welcome to Fleetrify",
      description: "Login to manage logistics and fleet operations",
    },
    {
      title: "Real-time Fleet Insights",
      description: "Get live updates and analytics on every vehicle in your fleet",
    },
    {
      title: "Simplify Logistics Management",
      description:
        "Automate routing, tracking, and reporting — all in one platform",
    },
  ];

  return (
    <div className="relative min-h-screen lg:flex">
      {/* video section */}
      <div className="relative w-full lg:w-[45%] h-screen lg:sticky top-0 flex-shrink-0">
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={FleetrifyBgs} type="video/mp4" />
        </video>

        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

        <div>
          <CarouselCard slides={slides} />
        </div>
      </div>

      {/* form Section */}
      <div className="mt-5 mb-10 w-full lg:w-[55%] lg:static absolute inset-0 z-30 px-4 sm:px-6 lg:px-8 overflow-y-auto">
        <div className="min-h-screen flex items-center justify-center">
          <div className="w-full max-w-[850px] p-6 bg-white rounded-lg shadow lg:shadow-none space-y-6 mx-auto">
            <div className="text-center space-y-2">
              <h2 className="text-[24px] font-bold text-[#143887]">
                Let&apos;s set up your organization
              </h2>
            </div>

            <h5 className="text-[#000000] text-[16px] tracking-[0.01em] font-bold text-center">
              You will be the Head of Organisation           </h5>

            {/* CTA */}
            <div className="flex flex-col items-center space-y-4 pt-6">
              <button
                onClick={() =>
                  handleNext(() =>
                    navigate(FLEETRIFYROUTEPATH.INDIVIDUALPROFILE)
                  )
                }
                disabled={sending}
                className="bg-[#143887] text-white py-2 px-20 w-fit rounded-md hover:bg-blue-800 disabled:opacity-60"
              >
                {sending ? "Processing..." : "Next"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndividualSetUp;
